import React from "react";
// ANT DESIGN COMPONENTS
import { Dropdown, Menu, Space } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faTrash, faPenToSquare, faBan, faCalendarDay } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
	updateOrganization,
	updateOpenDrawerHolidays,
	updateFormAction,
	updateOpenModalDeleteOrganization,
} from "../../../redux/organizations/organizationSlice";

// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { RootState } from "../../../app/store";
import { OrganizationInterface } from "../../../interfaces/Organizations.interface";

export default function OrganizationsTableActions({ selectedItem }: { selectedItem: OrganizationInterface }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenDrawerHolidays = () => {
		dispatch(updateOrganization(selectedItem));
		dispatch(updateOpenDrawerHolidays(true));
	};

	const handleOpenModalEdit = () => {
		dispatch(updateOrganization(selectedItem));
		dispatch(updateFormAction("edit"));
	};

	const handleOpenModalDelete = () => {
		dispatch(updateOrganization(selectedItem));
		dispatch(updateOpenModalDeleteOrganization(true));
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// ROW ACTIONS ************************************ */
	const manageActions = () => {
		const BLANK = {
			label: (
				<div className='generalStyles__tableActionBox'>
					<span>
						<FontAwesomeIcon className='generalStyles__error generalStyles__mrFix' icon={faBan} />
						{t("general.noActions")}
					</span>
				</div>
			),
			key: "0",
		};

		const HOLIDAYS = validatePermission("holidays-view", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faCalendarDay}
							text={t("general.holidays")}
							onClick={handleOpenDrawerHolidays}
						/>
					),
					key: "2",
			  }
			: null;

		const EDIT = validatePermission("orgs-update", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faPenToSquare}
							text={t("organizationManagement.edit")}
							onClick={handleOpenModalEdit}
						/>
					),
					key: "3",
			  }
			: null;

		const DELETE = validatePermission("orgs-delete", permissions)
			? {
					label: (
						<TableActionsMenuItem
							icon={faTrash}
							text={t("organizationManagement.delete")}
							onClick={handleOpenModalDelete}
						/>
					),
					key: "4",
			  }
			: null;

		// return object with valid actions
		if (EDIT || DELETE || HOLIDAYS) {
			return [EDIT, HOLIDAYS, DELETE];
		}
		return [BLANK];
	};

	const menu = <Menu items={manageActions()} />;

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<Dropdown overlay={menu} trigger={["click"]}>
				<Space className='generalStyles__hoverCursor'>
					<FontAwesomeIcon icon={faEllipsis} />
				</Space>
			</Dropdown>
		</div>
	);
}
